import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, SidePanel } from 'design-system-web';

function CoverageHoursPanelContent() {
  return null;
}

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function CreateCoverageHoursPanel({ isOpen, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <SidePanel
      id="create-coverage-hours-panel"
      isOpen={isOpen}
      onClose={onClose}
      header={t(
        'web.admin.serviceRequest.settings.coverageHours.create.title'
      )}
      size="small"
      backdropEnabled
      footerActions={
        <>
          <Button variant="primary" size="large" disabled>
            {t(
              'web.admin.serviceRequest.settings.coverageHours.create.save'
            )}
          </Button>
          <Button variant="secondary" size="large" onClick={onClose}>
            {t(
              'web.admin.serviceRequest.settings.coverageHours.create.cancel'
            )}
          </Button>
        </>
      }
    >
      <CoverageHoursPanelContent />
    </SidePanel>
  );
}
